const ctx = import.meta.webpackContext("./", {
  recursive: true,
  regExp: /\.(js|ts|tsx)$/,
});
ctx.keys().forEach(ctx);
